import React, { memo } from 'react';
import Button from '../../../components/Button';
import palette from '../../../components/styles/palette';

const ChangePasswordButton = ({ disabled, handleChangePassword }) => (
  <Button
    border="1px solid #E3AD1A"
    bgColor={palette.yellow}
    bgColorDisabled="rgba(255,213,0, 0.38)"
    color={palette.typography.black.medium}
    onClick={handleChangePassword}
    variant="contained"
    disableElevation
    disabled={disabled}
    data-testid="change-password"
  >
    Change Password
  </Button>
);

export default memo(ChangePasswordButton);
